//COnvert table to CSV
export const convertToCSV = (data) => {  
    const headers = Object.keys(data[0]);  
    const csvRows = data.map(row => headers.map(header => JSON.stringify(row[header], replacer)).join(','));  
    return [headers.join(','), ...csvRows].join('\r\n');  
};  
 
// download CSV file
export const downloadCSV = (csv, filename) => {  
    const blob = new Blob([csv], { type: 'text/csv' });  
    const url = window.URL.createObjectURL(blob);  
    const a = document.createElement('a');  
    a.setAttribute('hidden', '');  
    a.setAttribute('href', url);  
    a.setAttribute('download', filename);  
    document.body.appendChild(a);  
    a.click();  
    document.body.removeChild(a);  
};  
  
const replacer = (key, value) => (value === null ? '' : value);  
